module.exports = {"231005001":"先锋街道","231005002":"火炬街道","231005003":"立新街道","231005004":"牡丹街道","231005005":"江滨街道","231005006":"沿江街道","231005100":"温春镇","231005201":"海南朝鲜族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/231005.json
// module id = 776
// module chunks = 0